/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365 from '@msdyn365-commerce/core';

import { IMobileProps, VariantType } from './isMobile.props';

/**
 * IsMobile component.
 * @param props
 */
export const isMobile = (props: IMobileProps) => {
    const { variant, context } = props;
    switch (variant) {
        case VariantType.Browser:
            if (MsDyn365.isBrowser && window.innerWidth) {
                const gridSettings = context?.gridSettings;
                if (gridSettings) {
                    if (gridSettings.xs && window.innerWidth <= gridSettings.xs.w) {
                        return 'xs';
                    } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
                        return 'sm';
                    } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                        return 'md';
                    } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                        return 'lg';
                    }
                    return 'xl';
                }
            }

            return 'lg';
        case VariantType.Viewport:
            const viewport = context?.device?.Type === 'Mobile' ? 'xs' : 'lg';
            return viewport;
        default:
            return 'lg';
    }
};
